<template lang="html">
  <div id="stacked-bar-placeholder" />
</template>

<script>
  /*eslint-disable */

  import { mapGetters } from 'vuex';

  // NOTE: importing d3 from node_modules is currently breaking webpack
  // index.html is importing it through CDN

  export default {
    data() {
      return {
        filtered_legends: [
          'all',
          'new_idea',
          'challenge',
          'build_on',
          'question',
          'hand_raise',
        ],
      };
    },
    computed: {
      ...mapGetters(['getClassSummaryLD']),
    },
    mounted() {
      const d3 = window.d3version4;
      // Function that gets the initial data from the state
      // Also used for filtering by hand raise type
      const data = () => {
        return this.getClassSummaryLD.student_participations
          .map((s) => {
            return {
              student_name: s.user_name,
              student_avatar: s.user_avatar,
              new_idea: this.filtered_legends.includes('new_idea')
                ? s.turns_data.new_idea
                : 0,
              build_on: this.filtered_legends.includes('build_on')
                ? s.turns_data.build_on
                : 0,
              challenge: this.filtered_legends.includes('challenge')
                ? s.turns_data.challenge
                : 0,
              hand_raise: this.filtered_legends.includes('hand_raise')
                ? s.turns_data.hand_raise
                : 0,
              question: this.filtered_legends.includes('question')
                ? s.turns_data.question
                : 0,
              turns_total: s.turns_data.turns_total,
            };
          })
          .sort((a, b) => {
            return a.turns_total - b.turns_total;
          });
      };

      // Student with the most amount of turns
      const mostTurns = Math.max(...data().map((s) => s.turns_total), 0);

      const handType = [
        'new_idea',
        'challenge',
        'build_on',
        'question',
        'hand_raise',
      ];

      // SVG sizes and margins and d3 native calcs
      const margin = { top: 90, right: 5, bottom: -30, left: 120 };
      const width = 960 - margin.left - margin.right;
      const height = data().length * 100 - margin.top - margin.bottom;
      const color = d3.scaleOrdinal([
        '#72CCD7',
        '#EB2D7C',
        '#157F1F',
        '#00008B',
        '#FFA500',
      ]);
      // const color = d3.scaleOrdinal(['#3dbca4', '#eb4e2f', '#3b86c7', '#393e41', '#ffd201'])
      // const color = d3.scaleOrdinal(['#72ccd7', '#eb2d7C', '#ffd201', '#283248'])
      const stack = d3.stack().keys(handType).offset(d3.stackOffsetNone);
      const xScale = d3.scaleLinear().rangeRound([0, width]);
      const yScale = d3.scaleBand().rangeRound([height, 0]).padding(0.1);
      const xAxis = d3.axisBottom(xScale);
      const yAxis = d3.axisLeft(yScale);

      let minHeight = height < 400 ? (minHeight = 400) : (minHeight = height);

      // The main SVG
      const svg = d3
        .select('#stacked-bar-placeholder')
        .append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', minHeight + margin.top + margin.bottom)
        .append('g')
        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

      // Graph legends
      const legendContainer = svg
        .append('g')
        .attr('class', 'legend')
        .attr('transform', 'translate(-92,-58)');

      const legends = legendContainer
        .selectAll()
        .data(handType)
        .enter()
        .append('g')
        .attr('transform', (d, i) => `translate(${i * 110}, 0)`);

      legends
        .append('rect')
        .attr('class', 'legends')
        .attr('stroke', 'gray')
        .attr('height', 20)
        .attr('width', 20)
        .style('fill', (d, i) => color(i))
        .style('cursor', 'pointer');

      legends
        .append('text')
        .attr('class', 'legend-text')
        .attr('x', 28)
        .attr('y', 13)
        .style('cursor', 'default')
        .text((d, i) => {
          switch (d) {
            case 'build_on':
              return 'Build On';
              break;
            case 'challenge':
              return 'Challenge';
              break;
            case 'hand_raise':
              return 'Added by Teacher';
              break;
            case 'new_idea':
              return 'New Idea';
              break;
            case 'question':
              return 'Question';
              break;
            default:
          }
        });

      // Gets the first stack with the initial data,
      // we can later pass new data to it.
      let layersX = stack(data());

      // Scale for X, the result is the student with most turns times 2 (for scaling)
      xScale.domain([0, mostTurns * 2]).nice();
      yScale.domain(data().map((d) => d.student_name));

      // Function that draws the stacked layers
      const draw = (data) => {
        const layer = svg
          .selectAll('.layer')
          .data(layersX)
          .enter()
          .append('g')
          .attr('class', 'layer')
          .attr('id', (d, i) => `layer-${i}`)
          .style('fill', (d, i) => color(i));

        layer
          .selectAll()
          .data((d) => d)
          .enter()
          .append('rect')
          .attr('y', (d) => yScale(d.data.student_name))
          .attr('x', (d) => xScale(d[0]))
          .attr('height', 35)
          // .attr('height', yScale.bandwidth() - 35)
          .on('mouseover', function (d) {
            d3.select(this.parentNode)
              .append('text')
              .text(d[1] - d[0])
              .attr('y', yScale(d.data.student_name) - 10)
              .attr('x', xScale(d[0]) + 1)
              .attr('font-size', '21px')
              .attr('font-weight', 'bold')
              .transition()
              .duration(700)
              .style('fill', 'black');
          })
          .on('mouseout', function (d) {
            d3.select(this.parentNode).selectAll('text').remove();
          })
          .transition()
          .duration(500)
          .attr('width', (d) => xScale(d[1]) - xScale(d[0]));
      };

      // Call the initial draw
      draw(data());

      // Filter by hand raise type and redraw the layers
      d3.selectAll('.legends').on('click', (d, i) => {
        this.filtered_legends[0] === d
          ? (this.filtered_legends = [
              'all',
              'new_idea',
              'challenge',
              'build_on',
              'question',
              'hand_raise',
            ])
          : (this.filtered_legends = [d]);
        layersX = stack(data());
        d3.selectAll('.layer')
          .selectAll('rect')
          .transition()
          .duration(700)
          .attr('width', 0);

        d3.selectAll('.legends')
          .transition()
          .duration(300)
          .style('fill', (e) =>
            this.filtered_legends.length > 1
              ? color(e)
              : e === d
              ? color(i)
              : '#D3D3D3'
          );

        setTimeout(() => {
          d3.selectAll('.layer').remove();
          draw(data());
        }, 700);
      });

      // Append the labels (student name and student avatar)
      const label = svg
        .selectAll()
        .data(layersX)
        .enter()
        .filter((d, i) => i === 0)
        .append('g')
        .attr('class', 'label');

      label
        .selectAll()
        .data((d) => d)
        .enter()
        .append('defs')
        .append('pattern')
        .attr('id', (d, i) => `avatar-${i}`)
        .attr('width', 1)
        .attr('height', 1)
        .append('image')
        .attr('xlink:href', (d) => d.data.student_avatar)
        .attr('width', 46)
        .attr('height', 46);

      label
        .selectAll()
        .data((d) => d)
        .enter()
        .append('circle')
        .attr('cx', -68)
        .attr('cy', (d) => yScale(d.data.student_name) + 20)
        .attr('r', 23)
        .style('fill', (d, i) => `url(#avatar-${i})`);

      label
        .selectAll()
        .data((d) => d)
        .enter()
        .append('text')
        .attr('text-anchor', 'middle')
        .attr('x', -70)
        .attr('y', (d) => yScale(d.data.student_name) + 55)
        .text((d) => d.data.student_name);
    },
  };

  /*eslint-enable */
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  .axis text
    font: 10px sans-serif

  .axis line,
  .axis path
    fill: none
    stroke: #000
    shape-rendering: crispEdges

  .path-line
    fill: none
    stroke: yellow
    stroke-width: 1.5px

  svg
    background: #f0f0f0
</style>



// WEBPACK FOOTER //
// horizontalStackedBar.vue?01964526